import { createApiSaga } from '../../../sagaGenerator';
import {
  apiDelete, apiGet, apiPatch,
} from '../../../../middleware/api';
import {
  DELETE_VOLCANO_LOCATION_REQUEST,
  DELETE_VOLCANO_LOCATION_SUCCESS,
  DELETE_VOLCANO_LOCATION_FAILURE,
  GET_VOLCANO_LOCATION_DATA_REGION_REQUEST,
  GET_VOLCANO_LOCATION_DATA_REGION_SUCCESS,
  GET_VOLCANO_LOCATION_DATA_REGION_FAILURE,
  VOLCANO_LOCATION_DATA_BULK_EDIT_FAILURE,
  VOLCANO_LOCATION_DATA_BULK_EDIT_REQUEST,
  VOLCANO_LOCATION_DATA_BULK_EDIT_SUCCESS,
} from './volcanoLocationDataReducer';


const bulkEditVolcanoLocsSaga = createApiSaga({
  apiFunction: apiPatch,
  generateApiConfig: action => ({ endpoint: '/volcanolocs', ...action }),
  requestType: VOLCANO_LOCATION_DATA_BULK_EDIT_REQUEST,
  successType: VOLCANO_LOCATION_DATA_BULK_EDIT_SUCCESS,
  failureType: VOLCANO_LOCATION_DATA_BULK_EDIT_FAILURE,
  successMessage: 'Saved',
});


const deleteVolcanoLocationSaga = createApiSaga({
  apiFunction: apiDelete,
  generateApiConfig: action => ({ endpoint: `/volcanolocs/${action.id}`, ...action }),
  requestType: DELETE_VOLCANO_LOCATION_REQUEST,
  successType: DELETE_VOLCANO_LOCATION_SUCCESS,
  failureType: DELETE_VOLCANO_LOCATION_FAILURE,
  successMessage: 'Deleted',
});

const getRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/regions', ...action }),
  requestType: GET_VOLCANO_LOCATION_DATA_REGION_REQUEST,
  successType: GET_VOLCANO_LOCATION_DATA_REGION_SUCCESS,
  failureType: GET_VOLCANO_LOCATION_DATA_REGION_FAILURE,
});

export const volcanoLocationDataSagas = [
  bulkEditVolcanoLocsSaga,
  deleteVolcanoLocationSaga,
  getRegionsSaga,
];
